// src/components/ui/ConfirmHost.js
// ============================================================================
// Host del modal de CONFIRMACIÓN global. Se monta UNA sola vez en App.js.
// ----------------------------------------------------------------------------
// Escucha el singleton `confirmar` (src/utils/confirmar.js) y renderiza un
// <Modal> con el mensaje + botones Cancelar / Confirmar. Resuelve la promesa
// con true (confirmar) o false (cancelar / X / overlay). Tokenizado.
// ============================================================================
import React, { useState, useEffect } from 'react';
import Modal from '../Modal';
import { _registrarHost } from '../../utils/confirmar';
import { ExclamationTriangleIcon, QuestionMarkCircleIcon, CheckIcon, XMarkIcon } from './Icons';

function ConfirmHost() {
  const [actual, setActual] = useState(null);

  useEffect(() => _registrarHost((solicitud) => setActual(solicitud)), []);

  const responder = (valor) => {
    if (actual) {
      actual.resolver(valor);
      setActual(null);
    }
  };

  if (!actual) return null;

  const peligro = !!actual.peligro;
  const TituloIcon = peligro ? ExclamationTriangleIcon : QuestionMarkCircleIcon;
  const colorAcento = peligro ? 'var(--color-peligro)' : 'var(--color-primario)';

  return (
    <Modal
      isOpen
      onClose={() => responder(false)}
      size="small"
      title={
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: colorAcento, display: 'inline-flex', flexShrink: 0 }}>
            <TituloIcon className="w-6 h-6" />
          </span>
          <span>{actual.titulo || 'Confirmar acción'}</span>
        </span>
      }
    >
      <p style={{ margin: '0 0 20px 0', lineHeight: 1.5, color: 'var(--color-texto)', whiteSpace: 'pre-line' }}>
        {actual.mensaje}
      </p>

      <div
        style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'flex-end',
          flexWrap: 'wrap',
        }}
      >
        <button
          className="btn-press hover-bright"
          onClick={() => responder(false)}
          style={{
            flex: '1 1 auto',
            minWidth: '120px',
            padding: '10px 20px',
            fontSize: '15px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            background: 'var(--color-neutro-solido)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          <XMarkIcon className="w-5 h-5" /> {actual.textoCancelar || 'Cancelar'}
        </button>

        <button
          className="btn-press hover-bright"
          onClick={() => responder(true)}
          style={{
            flex: '1 1 auto',
            minWidth: '120px',
            padding: '10px 20px',
            fontSize: '15px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            background: colorAcento,
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          <CheckIcon className="w-5 h-5" /> {actual.textoConfirmar || 'Confirmar'}
        </button>
      </div>
    </Modal>
  );
}

export default ConfirmHost;
